import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Hidden from "@mui/material/Hidden";
import reactLogo from "dan-images/logo/react.webp";
import reduxLogo from "dan-images/logo/redux.webp";
import muiLogo from "dan-images/logo/mui.webp";
import routerLogo from "dan-images/logo/react_router.webp";
import webpackLogo from "dan-images/logo/webpack.webp";
import jssLogo from "dan-images/logo/jss.webp";
import TechnologyParallax from "./TechnologyParallax";
import Title from "./Title";
import isea from "/app/images/iseapmu.webp";
import cdac from "/app/images/services/service.webp";
import vlab from "/app/images/services/vlabs.webp";
import sso from "/app/images/services/sso-new.webp";
import useStyles from "./landingStyle-jss";
import "./Landing.css";

function Technology(props) {
  const { slideMode } = props;
  const { classes, cx } = useStyles();

  return (
    <div className={classes.tech}>
      {!slideMode && <TechnologyParallax />}
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="The Platform"
          desc="Integrated all your services at one platform"
          align="center"
          monocolor={slideMode && true}
        />
        <Grid container className={classes.root} spacing={3}>
          <Grid item sm={4} xs={12}>
            <div
              className={` fig1 ${cx(
                classes.wool,
                slideMode && classes.slideMode
              )}`}
            >
              <figure>
                <img src={isea} alt="isea" />
              </figure>
              <Typography variant="h5" className={classes.react}>
                ISEA
              </Typography>
            </div>
            <div
              className={`fig2 ${cx(
                classes.wool,
                slideMode && classes.slideMode
              )}`}
            >
              <figure>
                <img src={cdac} alt="cdac" />
              </figure>
              <Typography variant="h5" className={classes.router}>
                CDAC
              </Typography>
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <div className={classes.centerTech}>
              <div
                className={` fig3 ${cx(
                  classes.wool,
                  slideMode && classes.slideMode
                )}`}
              >
                <figure>
                  <img src={vlab} alt="Virtual Lab" />
                </figure>
                <Typography variant="h5" className={classes.redux}>
                  Virtual Lab
                </Typography>
              </div>
              <Hidden mdDown>
                <Button variant="contained" size="large" color="secondary">
                  Request To Integrate your services
                </Button>
              </Hidden>
              <div
                className={` fig4 ${cx(
                  classes.wool,
                  slideMode && classes.slideMode
                )}`}
              >
                <figure>
                  <img src={sso} alt="Stay Safe Online" />
                </figure>
                <Typography variant="h5" className={classes.webpack}>
                  Stay Safe Online
                </Typography>
              </div>
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <div
              className={` fig5 ${cx(
                classes.wool,
                slideMode && classes.slideMode
              )}`}
            >
              <figure>
                <img src={isea} alt="isea" />
              </figure>
              <Typography variant="h5" className={classes.mui}>
                ISEA
              </Typography>
            </div>
            <div
              className={` fig6 ${cx(
                classes.wool,
                slideMode && classes.slideMode
              )}`}
            >
              <figure>
                <img src={cdac} alt="CDAC" />
              </figure>
              <Typography variant="h5" className={classes.jss}>
                CDAC
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

Technology.propTypes = {
  slideMode: PropTypes.bool,
};

Technology.defaultProps = {
  slideMode: false,
};

export default Technology;
